<template>
  <div>
    <a href="#" @click.prevent="dialog = true"><v-icon color="primary">mdi-information</v-icon> View the description of the additional benefits</a>
    <v-dialog
        v-model="dialog"
        width="650"
    >
      <v-card class="tw-px-2">
        <card-title>Cost Add Ons</card-title>
        <v-card-text class="tw-mt-5">

          <strong>POLITICAL VIOLENCE TERRORISM & SABOTAGE</strong>
          <br>
          This cover is deemed to include loss caused by political violence terrorism and sabotage subject to the terms, conditions and exceptions as contained under the standard Pacis Political Violence Terrorism & Sabotage policy answered
          <br> <br>

          <strong>OWN DAMAGE EXCESS PROTECTOR CLAUSE</strong>
          <br>
          This is an additional cover that allows the insurance cover provided by this policy to be extended to include accidental own damage excess payable to the company in respect of claims made on the motor vehicle subject to the minimum excess stated in the policy. It is further noted that in the event of a payment of a claim under this extension, the insurer will have earned the full extension premium notwithstanding that the payment be less than the indemnity provided by the extension, cover under the extension shall be forfeited and may be reinstated at the discretion of the company at an additional premium of not less than the amount originally charged.
          <br> <br>

          <strong>LOSS OF USE EXTENSION</strong>
          <br>
          This additional cover allows the company to reimburse to the Insured against proof of payment of hire charges of an amount shown in the schedule per day for a maximum period of ten (10) days in any one period of insurance (excluding the first three days of each and every claim from the date the occurrence is reported to the company) towards the cost of hiring alternative transport .This benefit will only be payable in the event of a claim being accepted under Part 1 of this section for Loss of or damage to the insured Motor Vehicle. FIRST THREE DAYS EXCESS MAXIMUM KSHS.3,000/= PER DAY MAX. KSHS.30,000/= PER EVENT. (REGISTERED CAR HIRE FIRMS ONLY)
          <br> <br>

          <strong>FULL EXCESS PROTECTOR CLAUSE</strong>
          <br>
          This is an additional cover that allows the insurance cover provided by this policy to be extended to include accidental own damage and/or theft excess payable to the company in respect of claims made on the motor vehicle/s subject to the minimum excess stated in the policy. It is further noted that in the event of a payment of a claim under this extension, the Insurer will have earned the full extension premium notwithstanding that the payment be less than the indemnity provided by the extension, cover under the extension shall be forfeited and may be reinstated at the discretion of the company at an additional premium of not less than the amount originally charged.
          <br> <br>

          <strong>TRAVEL EMBEDED</strong>
          <br>
          This is a worldwide cover that can be bought as a rider at an additional premium to cover the insured while traveling outside the country. It is eligible for membership up to 80 years, It gives comprehensive protection for all you travels worldwide for only 1,000 /-
          Benefits
          • Medical and related expenses ie. Emergency hospitalization abroad
          • Cover for you baggage ie loss or delivery delays
          • Travel inconveniences such as cancelation, missed departure or travel delays
          • Personal accident cover for accidental death or Permanent total disability
          • Personal liability cover up to 100,000/-
          • Legal assistance abroad like lawyers expense

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="error"
              text
              @click="dialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';

export default {
  name: 'BenefitsDescription',
  components: { CardTitle },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
